/**
 * Bilingual names (brief §7, owner decision I4): Arabic and English, at least one of them is present; readers fall
 * back to the other language. Mirrors `BilingualName` of the backend shared kernel. Blank values count as absent.
 */
export interface BilingualNameLike {
  nameAr?: string | null | undefined;
  nameEn?: string | null | undefined;
}

const present = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim() ?? "";
  return trimmed === "" ? null : trimmed;
};

/** The name in `language` (`ar…` = Arabic, anything else = English), falling back to the other language. */
export function bilingualName(entity: BilingualNameLike, language: string): string {
  const ar = present(entity.nameAr);
  const en = present(entity.nameEn);
  return language.toLowerCase().startsWith("ar") ? (ar ?? en ?? "") : (en ?? ar ?? "");
}

/** True when at least one of the two names is given (I4 validation, same rule as the API). */
export function hasBilingualName(entity: BilingualNameLike): boolean {
  return present(entity.nameAr) !== null || present(entity.nameEn) !== null;
}
